import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './icon-button.scss';
import SvgIcon from '../svg-icon/svg-icon';

const IconButton = ({ type, enabled, callback }) => {
    enabled = enabled || 'enabled';
    return (
        <div
            role="button"
            tabIndex="-1"
            className={`${css['icon-button']} ${css[enabled]}`}
            onClick={() => callback(type)}>
            <SvgIcon type={type} active={enabled} />
        </div>
    );
};
/**
 * Define the type of properties that can be set on this component
 */
IconButton.propTypes = {
    type: PropTypes.string,
    callback: PropTypes.func,
    enabled: PropTypes.string
};

export default styleable(css)(IconButton);



// WEBPACK FOOTER //
// ./components/icon-button/icon-button.js